export default __webpack_public_path__ + "static/media/006-deer.0b5cde95.svg";